import { EMPTY_CHARGE_WAIVER_MODEL } from 'presentation/model/ChargeWaiver/ChargeWaiverModel';
import { useState } from 'react';
import { createContainer } from "react-tracked";

const {
    Provider: ChargeWaiverProvider,
    useTracked: useChargeWaiverTracked
} = createContainer(() => useState(EMPTY_CHARGE_WAIVER_MODEL), {concurrentMode: true});
export { ChargeWaiverProvider, useChargeWaiverTracked };

